import script from "./FooterColumnsDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterColumnsDefault.vue?vue&type=script&setup=true&lang=js"

import "./FooterColumnsDefault.vue?vue&type=style&index=0&id=2f1ce137&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1ce137"]])

export default __exports__